import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Container, Table, Button, Alert, Col, Row } from 'react-bootstrap'
import { getItems, deleteItem } from '../actions/itemActions'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { useParams } from 'react-router-dom'
import PaginateItem from '../components/PaginateItem'
import { LinkContainer } from 'react-router-bootstrap'
import {
  EMPLOYEE_PERMISSIONS,
  hasEmployeePermission
} from '../constants/employeePermissions.js'

// Import icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

const ListItems = ({ match }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { pageNumberitem } = useParams() || 1
  const { keyword } = useParams()

  const itemList = useSelector((state) => state.itemList)
  const { loading, error, items, count, pagesitem, pageitem } = itemList

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  const isAuthenticated = Boolean(ownerInfo || userInfo)
  const canManageCatalog = hasEmployeePermission(
    userInfo,
    ownerInfo,
    EMPLOYEE_PERMISSIONS.CATALOG_MANAGE
  )

  const itemDelete = useSelector((state) => state.itemDelete)
  const { success: successDelete } = itemDelete

  const delItem = (id) => {
    if (window.confirm('Are you sure?')) {
      dispatch(deleteItem(id))
      dispatch({ type: 'ITEM_DELETE_RESET' })
    }
  }

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getItems(pageNumberitem, keyword))
    } else {
      dispatch({ type: 'ITEM_LIST_RESET' })
      navigate('/login')
    }
  }, [
    dispatch,
    navigate,
    isAuthenticated,
    userInfo,
    pageNumberitem,
    keyword,
    successDelete
  ])

  return (
    <Container>
      <Row>
        <Col>
          <PaginateItem pagesitem={pagesitem} pageitem={pageitem} />
        </Col>
        {canManageCatalog && (
          <>
            <Col>
              <LinkContainer to='/settings'>
                <Button variant='primary' size='sm' className='my-2'>
                  Add an item
                </Button>
              </LinkContainer>
            </Col>
          </>
        )}
      </Row>

      {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
      {count === 0 && <Message variant='info'>None Found</Message>}
      {loading ?
        <Loader />
      : error ?
        <Message variant='danger'>{error}</Message>
      : <Table striped bordered hover responsive className='table-sm'>
          <thead className='my-2'>
            <tr>
              <th>
                <h3 className='my-2'>Item</h3>
              </th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item._id}>
                <td>{item.item}</td>
                {canManageCatalog && (
                  <>
                    <td>
                      <Button
                        align='right'
                        variant='danger'
                        size='sm'
                        onClick={() => delItem(item._id)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      }
    </Container>
  )
}

export default ListItems
